import IRISLogoImage from '../assets/IrisLogo.png';
import DecompInsightsNavigation from '../assets/Navigaiton-decom insight (1).png';
import IRISNavigation from '../assets/Navigaiton-decom insight.png';
import DemandModelNavigation from '../assets/Navigation-demand-model.png';
import DCPAnalatics from '../assets/dcp-analytics.png';
import DCPConsumption from '../assets/dcp-consumption.png';
import DCPImage from '../assets/dcp.png';
import DecompIrisLaunchImage from '../assets/decomp.png';
import DemandModelIRIS from '../assets/demand-model 101.png';
import DecompInsightsInterpretation from '../assets/demand-model 102.png';
import DemandModelInterpretation from '../assets/demand-model 103.png';
import DemandIrisLaunchImage from '../assets/demand.png';
import IRISDrivers from '../assets/drivers.png';
import Octagon from '../assets/faqicons/alert-octagon.svg';
import Container from '../assets/faqicons/container.svg';
import DataFaq from '../assets/faqicons/data.svg';
import DataFlowOne from '../assets/faqicons/dataflow-02.svg';
import DataFlowTwo from '../assets/faqicons/dataflow-04.svg';
import Eye from '../assets/faqicons/eye.svg';
import HomeCardDecompInsights from '../assets/homecarddecomp-insights.png';
import HomeCardDecomp from '../assets/homecarddecomp.png';
import HomeCardDemand from '../assets/homecarddemand.png';
import DecompInsightsHowToUse from '../assets/how-to-use-decomp-insight.png';
import AlertManuIcon from '../assets/icons/alert-circle.png';
import NetFlowAlertIcon from '../assets/icons/alert-circle.svg';
import ArrowLeft from '../assets/icons/arrow-narrow-left.svg';
import ArrowUpRight from '../assets/icons/arrow-up-right.svg';
import BellRing from '../assets/icons/bell-ringing.svg';
import bookOpen from '../assets/icons/book-open-01.png';
import CopyIconBlue from '../assets/icons/copy-blue.svg';
import CopyIcon from '../assets/icons/copy.svg';
import DataflowKeyfeatureOne from '../assets/icons/dataflow-keyfeatureone.svg';
import DataflowKeyfeaturetwo from '../assets/icons/dataflow-keyfeaturetwo.svg';
import DemandButtonIcon from '../assets/icons/demand-button.png';
import DotsIcon from '../assets/icons/dots-vertical.svg';
import DownloadIcon from '../assets/icons/download.svg';
import EditIcon from '../assets/icons/edit-02.svg';
import FileIcon from '../assets/icons/file-blue.svg';
import FilterLines from '../assets/icons/filter-lines.svg';
import HeaderBackground from '../assets/icons/header-background-Image.svg';
import helpCircle from '../assets/icons/help-circle.png';
import HomeLineIcon from '../assets/icons/home-line.svg';
import icon001 from '../assets/icons/icon001.svg';
import ExternalLink from '../assets/icons/link-external.svg';
import MarkerPin from '../assets/icons/marker-pin.svg';
import MessageQuestionCircle from '../assets/icons/message-question-circle.svg';
import messageSmileCircle from '../assets/icons/message-smile-circle.png';
import Netflow from '../assets/icons/netflow-default.svg';
import PhoneBlueIcon from '../assets/icons/phone.svg';
import MassEditRefreshIcon from '../assets/icons/refresh-icon.svg';
import ResetIcon from '../assets/icons/reset-icon.svg';
import Scales from '../assets/icons/scales.svg';
import ScenarioExpand from '../assets/icons/scenario-expand.svg';
import ScenarioMinimize from '../assets/icons/scenario-minimize.svg';
import ScenarioPlanner from '../assets/icons/scenario-planner.svg';
import ShareIcon from '../assets/icons/share-03.svg';
import PlusIcon from '../assets/icons/sp-plus.svg';
import IRISTeaser from '../assets/iris-teaser.png';
import LinkExternal from '../assets/link-external-02.svg';
import ProactiveALerting from '../assets/proactive alerting.png';
import ProactiveIrisLaunchImage from '../assets/proactive.png';
import ReleaseNotes from '../assets/releaseNotes-image.png';
import ReleaseVersion from '../assets/releaseVersion.png';

export const IMAGES_REPO = {
  AlertManuIcon,
  ArrowLeft,
  ArrowUpRight,
  BellRing,
  Container,
  CopyIcon,
  CopyIconBlue,
  DCPAnalatics,
  DCPConsumption,
  DCPImage,
  DataFaq,
  DataFlowOne,
  DataFlowTwo,
  DataflowKeyfeatureOne,
  DataflowKeyfeaturetwo,
  DecompInsightsHowToUse,
  DecompInsightsInterpretation,
  DecompInsightsNavigation,
  DecompIrisLaunchImage,
  DemandButtonIcon,
  DemandIrisLaunchImage,
  DemandModelIRIS,
  DemandModelInterpretation,
  DemandModelNavigation,
  DotsIcon,
  DownloadIcon,
  EditIcon,
  ExternalLink,
  Eye,
  FileIcon,
  FilterLines,
  HeaderBackground,
  HomeCardDecomp,
  HomeCardDecompInsights,
  HomeCardDemand,
  HomeLineIcon,
  IRISDrivers,
  IRISLogoImage,
  IRISNavigation,
  IRISTeaser,
  LinkExternal,
  MarkerPin,
  MassEditRefreshIcon,
  MessageQuestionCircle,
  NetFlowAlertIcon,
  Netflow,
  Octagon,
  PhoneBlueIcon,
  PlusIcon,
  ProactiveALerting,
  ProactiveIrisLaunchImage,
  ReleaseNotes,
  ReleaseVersion,
  ResetIcon,
  Scales,
  ShareIcon,
  bookOpen,
  helpCircle,
  homeImage: '/images/home/data-analysis.gif',
  icon001,
  img01: '/images/home/Image-3-p-500.png',
  img03: '/images/home/image-dummy.svg',
  messageSmileCircle,
  ScenarioExpand,
  ScenarioMinimize,
  ScenarioPlanner,
};
